export enum FamilyMemberRelationship {
  Spouse = 0,
  Dependent = 1,
}
